import { createContext, useContext, useState, useCallback } from 'react';

const RoleContext = createContext();

const initialState = {
  alertProps: {},
  hostMenu: [],
};

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  sort: { field: 'id', order: 'desc' },
};

const RoleProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = useCallback((payload) => setState((prev) => ({ ...prev, ...payload })), []);
  const updateFilterState = useCallback((payload) => setFilterState((prev) => ({ ...prev, ...payload })), []);
  const resetState = useCallback(() => setState(initialState), []);
  const resetFilterState = useCallback(() => setFilterState(initialFilterState), []);

  return <RoleContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>{children}</RoleContext.Provider>;
};

export const useRoleState = () => {
  return useContext(RoleContext);
};

export default RoleProvider;
